@if (recipeCards?.length > 0) {
  <sd-rich-paragraph
    [titleLevel]="2"
    [size]="SizeEnum.xl"
    [isDescription]="false"
    [brand]="brand"
    [contentData]="contentData"
  />
  <sd-recipe-slider
    [recipeCards]="recipeCards"
    [brand]="brand"
    (clicked)="onClickCard($event)"
  />
}
